import * as React from 'react';

export const Calendar = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.41016 9.66602C3.41016 9.2518 3.74594 8.91602 4.16016 8.91602H20.2016C20.6158 8.91602 20.9516 9.2518 20.9516 9.66602C20.9516 10.0802 20.6158 10.416 20.2016 10.416H4.16016C3.74594 10.416 3.41016 10.0802 3.41016 9.66602Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8145 2.25C16.2287 2.25 16.5645 2.58579 16.5645 3V5.96174C16.5645 6.37595 16.2287 6.71174 15.8145 6.71174C15.4002 6.71174 15.0645 6.37595 15.0645 5.96174V3C15.0645 2.58579 15.4002 2.25 15.8145 2.25Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.54297 2.25C8.95718 2.25 9.29297 2.58579 9.29297 3V5.96174C9.29297 6.37595 8.95718 6.71174 8.54297 6.71174C8.12876 6.71174 7.79297 6.37595 7.79297 5.96174V3C7.79297 2.58579 8.12876 2.25 8.54297 2.25Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.71498 4.95256C5.634 4.07897 6.91309 3.67188 8.36992 3.67188H15.9903C17.4504 3.67188 18.7302 4.07865 19.6479 4.95323C20.5712 5.83327 21.0304 7.094 21.0262 8.60132C21.0262 8.6011 21.0262 8.60154 21.0262 8.60132V16.8137C21.0262 18.3212 20.5649 19.5831 19.6415 20.4646C18.7234 21.341 17.4437 21.7504 15.9825 21.7504H8.36992C6.90859 21.7504 5.62787 21.3322 4.70972 20.4423C3.78785 19.5488 3.32617 18.2716 3.32617 16.7456V8.59984C3.32617 7.09167 3.79016 5.83167 4.71498 4.95256ZM5.74843 6.03976C5.18727 6.57317 4.82617 7.40215 4.82617 8.59984V16.7456C4.82617 17.9683 5.18958 18.8185 5.75368 19.3652C6.32151 19.9156 7.18767 20.2504 8.36992 20.2504H15.9825C17.1726 20.2504 18.0398 19.9198 18.6057 19.3796C19.1663 18.8445 19.5262 18.013 19.5262 16.8137V8.59984V8.59768C19.5297 7.39945 19.1716 6.57144 18.613 6.03908C18.0486 5.50115 17.1815 5.17187 15.9903 5.17187H8.36992C7.18317 5.17187 6.31539 5.50083 5.74843 6.03976Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4307 13.376C11.4307 12.9618 11.7665 12.626 12.1807 12.626C12.595 12.626 12.9313 12.9618 12.9313 13.376C12.9313 13.7902 12.5956 14.126 12.1813 14.126C11.7671 14.126 11.4307 13.7902 11.4307 13.376Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4307 16.8525C11.4307 16.4383 11.7665 16.1025 12.1807 16.1025C12.595 16.1025 12.9313 16.4383 12.9313 16.8525C12.9313 17.2668 12.5956 17.6025 12.1813 17.6025C11.7671 17.6025 11.4307 17.2668 11.4307 16.8525Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.41113 13.376C7.41113 12.9618 7.74692 12.626 8.16113 12.626C8.57535 12.626 8.91181 12.9618 8.91181 13.376C8.91181 13.7902 8.57603 14.126 8.16181 14.126C7.7476 14.126 7.41113 13.7902 7.41113 13.376Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.41113 16.8525C7.41113 16.4383 7.74692 16.1025 8.16113 16.1025C8.57535 16.1025 8.91181 16.4383 8.91181 16.8525C8.91181 17.2668 8.57603 17.6025 8.16181 17.6025C7.7476 17.6025 7.41113 17.2668 7.41113 16.8525Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4404 13.376C15.4404 12.9618 15.7762 12.626 16.1904 12.626C16.6046 12.626 16.9411 12.9618 16.9411 13.376C16.9411 13.7902 16.6053 14.126 16.1911 14.126C15.7769 14.126 15.4404 13.7902 15.4404 13.376Z"
      fill="#64748B"
    />
  </svg>
);
